var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 31.9059V11C23 6.02944 27.0295 2 32 2C36.9706 2 41 6.02944 41 11V14.0086",
    stroke: "#FAFAFA",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32.0078V53.0026C41 57.9732 36.9706 62.0026 32 62.0026C27.0295 62.0026 23 57.9732 23 53.0026V49.9576",
    stroke: "#FAFAFA",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 41H10.9762C6.01879 41 2 36.9706 2 32C2 27.0295 6.01879 23 10.9762 23H13.9829",
    stroke: "#FAFAFA",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 23H52.9833C57.9631 23 62.0001 27.0295 62.0001 32C62.0001 36.9706 57.9631 41 52.9833 41H50.0995",
    stroke: "#FAFAFA",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService2);
export default __webpack_public_path__ + "static/media/service2.d5bd16c7e1a76b19a72938579c076502.svg";
export { ForwardRef as ReactComponent };